import { Label } from "@patternfly/react-core";

export const SheetIdCell = ({ id, isSelected }) => {
    return isSelected ? (
        <Label isCompact variant="outline" status="success">
            {id}
        </Label>
    ) : (
        <span>{id}</span>
    );
};